.sn-call-to-action-type-6 {
  &__container {
    @include container;

    padding-top: 0;
  }

  &__inner {
    background-color: $background-color-brand-primary-darkest;
    border-radius: map-get($border-radii, lg);
    padding: var(--spacing-3xl) var(--spacing-xl);
    text-align: center;
    color: $color-neutral-white;

    @include desktop {
      padding: var(--spacing-5xl) var(--spacing-5xl);
    }

    .me-text--label {
      display: block;
      text-transform: uppercase;
      letter-spacing: 3px;
      font-size: map-get($font-sizes, md);
      font-weight: map-get($font-weights, bold);
      margin: 0 0 var(--spacing-sm);
    }

    .me-heading {
      display: block;
      font-size: map-get($font-sizes, 4xl);
      font-weight: map-get($font-weights, bold);
      line-height: map-get($line-heights, xl);
      margin: 0 0 var(--spacing-xl);

      @include desktop {
        font-size: map-get($font-sizes, 6xl);
      }
    }
  }

  &__action {
    display: inline-flex;

    .me-button {
      min-width: 208px;

      // CTA button: 208×48. The height comes from the padding — 24px line-height
      // + 2×2px border + 2×10px padding. The theme rule
      // `body.signnow [data-color-mode] .me-button--primary` is (0,3,1) and outranks the
      // three classes here, so the `[data-color-mode]` ancestor is matched too — (0,4,0).
      [data-color-mode] &.me-button--primary {
        padding: 0.625rem 1.2rem;
      }
    }
  }
}
